import { render, staticRenderFns } from "./hotel-group-company-list.vue?vue&type=template&id=0c949a0a"
import script from "./hotel-group-company-list.vue?vue&type=script&lang=ts"
export * from "./hotel-group-company-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports